import { useSyncExternalStore } from "react";

import { useConnectivity } from "@/features/offline/connectivity";

function subscribe(callback: () => void): () => void {
  window.addEventListener("online", callback);
  window.addEventListener("offline", callback);
  return () => {
    window.removeEventListener("online", callback);
    window.removeEventListener("offline", callback);
  };
}

/**
 * Online = the browser has a network **and** the shop's server answers (the T07-33 connectivity
 * monitor: heartbeat + live stream) — drives the offline banner, the P6 sell guard and every
 * "online only" button.
 */
export function useOnlineStatus(): boolean {
  const browser = useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  );
  const connectivity = useConnectivity();
  return browser && connectivity.state === "online";
}
